import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { divWithStyle } from './style/LayoutComponents';
import { vizPortalFontStyle } from './style/VizPortalStyles';

export const centeredStyle = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const CenteredMessageContainer = divWithStyle('CenteredMessageContainer', {
  ...vizPortalFontStyle,
  ...centeredStyle,
  fontSize: TabStyles.Typography.Sizing.XLarge,
  color: TabStyles.Colors.L8, // This is what VizPortal Client uses.
  textAlign: 'center',
});

export function CenteredMessage(props: { readonly message: string }): JSX.Element {
  return (
    <CenteredMessageContainer>
      {props.message}
    </CenteredMessageContainer>
  );
}
